import React, { useState, useEffect } from 'react'
import { Container, Row, Col, Form, Button } from 'react-bootstrap'
import { TextInput } from './commons/TextInput'
import { CheckboxInput } from './commons/CheckboxInput'
import { editSite } from '../../../api/fetch'

export const EditSite = (props) => {

    const [name, setName] = useState("")
    const [description, setDescription] = useState("")
    const [city, setCity] = useState("")
    const [currency, setCurrency] = useState("EUR")
    const [useCategory, setUseCategory] = useState(false)
    const [shareFoodItems, setShareFoodItems] = useState(false)
    const [isFormError, setIsFormError] = useState(false)

    useEffect(() => {
        setName(props.elementSelected.name)
        setDescription(props.elementSelected.description)
        if (props.elementSelected.place) {
            setShareFoodItems(props.elementSelected.place.share_food_items)
            const config = props.elementSelected.place.config
            setCity(config.city)
            setCurrency(config.currency)
            setUseCategory(config.useCategory)
        }
    }, [props.elementSelected])

    const handleCurrencyChange = (e) => {
        setCurrency(e.target.value)
    }

    const handleSubmit = () => {

        if (!(name && city)) {
            setIsFormError(true)
            return
        }
        setIsFormError(false)

        let siteRequest = {
            id: parseInt(props.elementSelected.id.split('-')[1]),
            contract_id: parseInt(props.parent.id.split('-')[1]),
            name: name,
            description: description,
            share_food_items: shareFoodItems,
            parent_id: props.elementSelected.place.parent_id,
            address: props.elementSelected.place.address,
            capacity: props.elementSelected.place.capacity,
            coordinate: props.elementSelected.place.coordinate,
            created_at: props.elementSelected.place.created_at,
            kind: "SITE",
            mpath: props.elementSelected.place.mpath,
            order: props.elementSelected.place.order,
            picto: props.elementSelected.place.picto,
            picto_cover: props.elementSelected.place.picto_cover,
            picture: props.elementSelected.place.picture,
            template: props.elementSelected.place.template,

            config: {
                city: city,
                currency: currency,
                useCategory: useCategory,
            }
        }

        postData(siteRequest)
    }

    const postData = (async (siteRequest) => {
        const method = 'PUT'
        const body = JSON.stringify(siteRequest)
        const headers = {
            'Content-Type': 'application/json',
        }
        await editSite({ method, body, headers }).then(() => { props.showSuccessForm() });
    })

    return (
        <Container>
            <Row className="title">
                <Col>
                    <h2>{name + " > Edit Site"}</h2>
                </Col>
            </Row>
            <Row className="name-description">
                <Col>
                    <Form.Label>*Name</Form.Label>
                    <TextInput value={name} setValue={setName} />
                </Col>
                <Col>
                    <Form.Label>Description</Form.Label>
                    <TextInput value={description} setValue={setDescription} />
                </Col>
            </Row>
            <Row className="sutitle-template">
                <h3>Config:</h3>
            </Row>
            <Row className="close-inputs">
                <Col xs={4}>
                    <Form.Label>*city:</Form.Label>
                </Col>
                <Col xs={8}>
                    <TextInput value={city} setValue={setCity} />
                </Col>
            </Row>
            <Row className="close-inputs">
                <Col xs={4}>
                    <Form.Label>currency:</Form.Label>
                </Col>
                <Col xs={8}>
                    <Form.Select value={currency} onChange={(e) => handleCurrencyChange(e)}>
                        <option value="EUR">EUR</option>
                        <option value="PTS">PTS</option>
                    </Form.Select>
                </Col>
            </Row>
            <Row className="close-inputs">
                <Col xs={4}>
                    <Form.Label>useCategory</Form.Label>
                </Col>
                <Col xs={8}>
                    <CheckboxInput value={useCategory} setValue={setUseCategory} />
                </Col>
            </Row>
            <Row className="close-inputs">
                <Col xs={4}>
                    <Form.Label>share_food_items</Form.Label>
                </Col>
                <Col xs={8}>
                    <CheckboxInput value={shareFoodItems} setValue={setShareFoodItems} />
                </Col>
            </Row>
            <Row className="justify-content-end submit-button" >
                <Col xs={2} className="text-end">
                    <Button className="bg-dark-blue" onClick={() => handleSubmit()}>Save</Button>
                </Col>
            </Row>
            {isFormError ? <Row className="error-message">Fill the inputs marked with *</Row> : <div />}
        </Container>
    )

}